import React from 'react'
import { useTranslation } from 'react-i18next'
import { WifiOff } from 'lucide-react'
import useCrashStore from '../store/useCrashStore'

/**
 * Плашка «Связь потеряна — ждём сервер» (§8.1).
 *
 * Показывается, когда тики пропали дольше OFFLINE_NOTICE_MS (3с) в фазе роста.
 * Снимается автоматически, как только приходит тик — см. onTick в store.
 */
const CrashOfflineNotice = () => {
  const { t } = useTranslation()
  const show = useCrashStore((s) => s.showOfflineNotice)
  const showReconnect = useCrashStore((s) => s.showReconnectNotice)

  if (!show && !showReconnect) return null

  return (
    <div className="absolute inset-0 z-30 flex items-center justify-center pointer-events-none">
      <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-dark-primary/90 border border-red-500/40 backdrop-blur-md shadow-lg">
        <WifiOff className="w-4 h-4 text-red-400" />
        <span className="text-sm font-medium text-red-300">
          {t('crash.notices.connectionLost')}
        </span>
      </div>
    </div>
  )
}

export default CrashOfflineNotice
